import TextField, { TextFieldProps } from "@/components/TextField";
import { InputAdornment } from "@/components/TextField";
import { SearchIcon } from "@/components/Icon";

const SearchTextField: React.FC<
  TextFieldProps & { iconPlacement?: "end" | "start" }
> = ({ iconPlacement = "end", ...props }) => (
  <TextField
    placeholder={props.placeholder || "Search"}
    variant={props.variant || "filled"}
    InputProps={{
      endAdornment:
        iconPlacement === "end" ? (
          <>
            <InputAdornment position="end">
              <SearchIcon />
            </InputAdornment>
          </>
        ) : null,
      startAdornment:
        iconPlacement === "start" ? (
          <>
            <InputAdornment position="end">
              <SearchIcon />
            </InputAdornment>
          </>
        ) : null,
    }}
    {...props}
  />
);

export default SearchTextField;
